import type { PeopleFilterType } from '@app/core/shared/interfaces/solutions-profile.interface';

/** Default logos for solutions people when the API has no `logo` URL. */
export const PEOPLE_PROFILE_LOGO_PLACEHOLDER: Record<PeopleFilterType, string> =
  {
    INSTALLER: 'assets/images/placeholders/installer-placeholder.png',
    ARCHITECT: 'assets/images/placeholders/architect-placeholder.png',
    SUPPLIER: 'assets/images/placeholders/supplier-placeholder.png',
    PROJECT_OWNER: 'assets/images/placeholders/owner-placeholder.png',
  };

const URL_SEGMENT_TO_TYPE: ReadonlyArray<{
  readonly pattern: string;
  readonly type: PeopleFilterType;
}> = [
  { pattern: '/installers/', type: 'INSTALLER' },
  { pattern: '/architects/', type: 'ARCHITECT' },
  { pattern: '/suppliers/', type: 'SUPPLIER' },
  { pattern: '/developers/', type: 'PROJECT_OWNER' },
];

/** Map `/solutions/{segment}/:id` to the matching placeholder asset. */
export function placeholderPathForSolutionsPersonDetailUrl(
  fullUrl: string
): string | null {
  const path = fullUrl.split('?')[0];
  for (const { pattern, type } of URL_SEGMENT_TO_TYPE) {
    if (path.includes(pattern)) {
      return PEOPLE_PROFILE_LOGO_PLACEHOLDER[type];
    }
  }
  return null;
}
